import React, { Component } from 'react'
import FileSender from '../../controller/FileSender'
import FileSaver from 'file-saver'

export default class DownLoad extends Component {

    state = {
        status : 'Checkig File',
        isPic : false
    }


    componentDidMount() {

        this.downloadFx()

    }

    downloadFx = () => {

        const pather = window.location.pathname
        const lengther = pather.length

        if(lengther >= 10) {

            const substracter = pather.substr(10, lengther)

            const lastThree = pather.slice(lengther - 3, lengther)
            const lowThree = lastThree.toLowerCase()


            let condition = {
                url : '/attach/' + substracter,
                responseType : 'blob'
            }
    
            FileSender(condition, res => {

                if(res.data === null) {

                    this.setState({
                        status : 'CODE 961 : Download Error'
                    })

                    return
                
                } else if( lowThree === 'gif' || lowThree === 'jpg' || lowThree === 'png' || lowThree === 'jfif') {

                    this.setState({ isPic : true })
                }
                
                
                else {              

                    FileSaver.saveAs(res.data, substracter)
                
                    this.setState({
                        status : 'CODE 773 : Download Success'
                    })

                    return
                }
            })

        } else {
            
            this.setState({

                status : 'CODE 934 : Link Error'

            })
        }
    }


    render() {

        const Banner = {
            backgroundImage: 'url("/dog.jpg")',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            height: '100vh'
        }

        const ImgStyle = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translateX(-50%) translateY(-50%)',
            marginLeft: '45px',
            maxWidth: 'calc(100vw - 90px)',
            textAlign: 'center'
        }

        const PicOrDown = () => {

            const pathName = window.location.pathname
            const lengther = pathName.length
            const imgName = pathName.substr(10, lengther)
            const imgUrl = '/' + imgName
            
                 
            if (!this.state.isPic) {

                return(
                    <p id='Denied'>{ this.state.status }</p>    
                )
            } else {

                return(
                    <div style={ImgStyle}>
                        <img src = {imgUrl} />
                    </div>
                )
            }
        }

        return (
            
            <div className='WideBanner' style={ Banner }>

                <PicOrDown />

            </div>
        )

    }

}



// WEBPACK FOOTER //
// ./src/components/etc/Download.js